module.exports = __webpack_public_path__ + "static/media/br_middle.9eeccff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/hundredDaysActivities/share/img/br_middle.png
// module id = 1525
// module chunks = 0